// extracted by mini-css-extract-plugin
export default {"infoBanner":"InfoBanner_infoBanner__a-Ln+","content":"InfoBanner_content__Eq-lM","title":"InfoBanner_title__OQQuS","body":"InfoBanner_body__xSSr6"};